import Enum from '../base/Enum';

/**
 * @typedef {Object} PurchaseStatusValue
 * @property {number} value
 * @property {string} label
 */


/**
 * @name PurchaseStatus
 *
 * @property {PurchaseStatusValue} None
 * @property {PurchaseStatusValue} Waiting
 * @property {PurchaseStatusValue} InAnalysis
 * @property {PurchaseStatusValue} Paid
 * @property {PurchaseStatusValue} Available
 * @property {PurchaseStatusValue} Disputed
 * @property {PurchaseStatusValue} Refunded
 * @property {PurchaseStatusValue} Canceled
 */
export default new Enum({
	None:       {value: 0, label: '-'},
	Waiting:    {value: 1, label: 'Aguardando pagamento'},
	InAnalysis: {value: 2, label: 'Em Análise'},
	Paid:       {value: 3, label: 'Pago'},
	Available:  {value: 4, label: 'Liberado'},
	Disputed:   {value: 5, label: 'Em disputa'},
	Refunded:   {value: 6, label: 'Devolvido'},
	Canceled:   {value: 7, label: 'Cancelado'}
});